// 06-10 — La bandeja que tiene delante quien mira (bandejas.ts): la lista y el Alt+↑/↓ del chat recorren la misma.
import { useMemo } from 'react';
import type { ContratadoDTO } from '../compartido/vocabulario';
import { useSantiPorAgente } from '../pelotas/porAgente';
import { useOficinaStore } from '../store';
import { claveVisible, enBandeja, miBandeja, pestanasBandeja } from './bandejas';

export function useBandeja(contratados: Record<string, ContratadoDTO>, subidas?: ReadonlyMap<string, { creadoEn: string }>, ahora?: number) {
  const yo = useOficinaStore((s) => s.yo);
  const vista = useOficinaStore((s) => s.bandejaVista);
  const enLaOficina = useMemo(() => Object.values(contratados), [contratados]);
  const mia = miBandeja(yo);
  const santi = useSantiPorAgente();
  const pestanas = useMemo(() => pestanasBandeja(enLaOficina, mia, santi, subidas, ahora), [enLaOficina, mia, santi, subidas, ahora]);
  const clave = claveVisible(pestanas, vista, mia);
  const visibles = useMemo(() => enBandeja(enLaOficina, clave), [enLaOficina, clave]);
  // Hasta saber quién mira no hay selector ni avisos de otros (un socio vería un instante los de Pau como suyos).
  return { yo, mia, pestanas, clave, visibles, enLaOficina, sabido: yo !== null, vista };
}
